





























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import FileUpload from "vue-upload-component";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    FileUpload
  }
})
export default class EmployerLogoUpload extends Vue {
  $router: VueRouter;
  $validator: Validator;

  notifierStore = useNotifierStore();
  portalCustomization = usePortalCustomizationStore();

  file = null;
  isSubmitting = false;
  isDeleting = false;
  accept = ".png,.svg";

  @Prop() employerId: number;

  mounted () {
    this.portalCustomization.getEmployerCustomLogo(this.employerId);
    this.initialize();
  }

  @Watch("portalCustomization.isEmployerLogoLoaded")
  initialize () {
    if (this.portalCustomization.employerLogoSrc && this.$refs.logo) {
      (this.$refs.logo as any).src = this.portalCustomization.employerLogoSrc;
    }
  }

  fileLogoChange (file) {
    if (!file) return;
    this.file = (document.getElementById("logo-asset") as any).files[0];
    const f = new FileReader();
    f.onload = () => (this.$refs.logo as any).src = f.result;
    f.readAsDataURL(this.file);
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.portalCustomization.saveEmployerCustomLogo({
          employerId: this.employerId,
          logoFile: this.file
        })
        .then(resp => {
          this.$nextTick(() => {
            this.notifierStore.setSuccess("employer custom logo saved", this.notifierStore.shortTimeout);
            this.isSubmitting = false;
            this.initialize();
          });
        })
        .catch(() => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Could not save employer logo", this.notifierStore.shortTimeout);
        });
  }
  onDelete () {
    if (this.isDeleting) {
      return;
    }
    this.isDeleting = true;
    this.portalCustomization.deleteEmployerCustomLogo(this.employerId)
        .then(_ => {
          this.$nextTick(() => {
            this.notifierStore.setSuccess("employer logo deleted", this.notifierStore.shortTimeout);
            this.initialize();
          });
        })
        .catch(() => {
          this.notifierStore.setDanger("Could not delete employer logo", this.notifierStore.shortTimeout);
        }).finally(() => {
          this.isDeleting = false;
        });
  }
  get deleteDisabled () {
    return this.isDeleting;
  }
  get hasCustomLogo (): boolean {
    return this.portalCustomization.employerLogoSrc !== null
      && this.portalCustomization.employerLogoSrc.length > 0;
  }
}
